<template>
  <v-btn
    fab small size="40" class="top-btn"
    :class="{
      'isFixed': fixed
    }"
    color="white"
    v-if="isScrolling"
    @click="goTop"
  >
    <v-icon>fas fa-chevron-up</v-icon>
    <translate>Up</translate>
  </v-btn>
</template>
<script>
export default {
  name: "ScrollTop",
  props: {
    fixed: {type: Boolean, default: true}
  },
  data() {
    return {
      scrollTimeOut: null,
      isScrolling: false
    };
  },
  computed: {},
  methods: {
    handleDebouncedScroll() {
      clearTimeout(this.scrollTimeOut)
      const _this = this
      this.scrollTimeOut = setTimeout(() => {
        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
        _this.isScrolling = !!(document.documentElement.scrollTop > (vh / 2))
      }, 100)
    },
    goTop() {
      document.documentElement.scrollTop = 0;
    }
  },
  mounted() {
    const _this = this
    document.getElementsByTagName('body')[0].onscroll = () => {
      console.log("scrolling");
      _this.handleDebouncedScroll()
    };
    _this.handleDebouncedScroll()
  },
};
</script>